import store from 'redux/redux'
import messages from './messages'
import Config from 'utils/config'

this.formatMessage = null

const importFormatter = importedFormatter => {
  this.formatMessage = importedFormatter
}

const getDefaultLanguage = () => {
  let defaultLanguage
  if (getLanguageFormURL()) {
    defaultLanguage = getLanguageFormURL()
  } else if (localStorage.getItem('defaultLanguage')) {
    defaultLanguage = localStorage.getItem('defaultLanguage')
  } else {
    defaultLanguage = getActualLanguage()
  }
  return defaultLanguage
}

const getLanguageFormURL = () => {
  const lang = window.location.pathname.split('/')[2]
  return lang
}

const getActualLanguage = () => {
  return store.getState().LANGUAGE.selectedLanguage
}

const getDimensionSubtitle = dimension => {
  dimension = Number(dimension)
  switch (dimension) {
    case 0:
      return this.formatMessage(messages.dimension_0_Subtitle)
    case 1:
      return this.formatMessage(messages.dimension_1_Subtitle)
    case 2:
      return this.formatMessage(messages.dimension_2_Subtitle)
    case 3:
      return this.formatMessage(messages.dimension_3_Subtitle)
    default:
      return 'Not Found'
  }
}

const getComposedDataSource = dataSource => {
  let composedDataSource = ''
  if (dataSource) {
    composedDataSource = this.formatMessage(messages.dataSource, { dataSource })
  }
  return composedDataSource
}

const getDimensionTitle = (dimension) => {
  // const panel = Config.getConfig().panel_text;
  // if ((dimension >= 0) & (dimension < panel.length)) {
  //   return panel[dimension].title
  // } else {
  //   return "Change me!"
  // }
  switch (Number(dimension)) {
    case 0:
      return this.formatMessage(messages.dimension_0_Title)
    case 1:
      return this.formatMessage(messages.dimension_1_Title)
    case 2:
      return this.formatMessage(messages.dimension_2_Title)
    case 3:
      return this.formatMessage(messages.dimension_3_Title)
    default:
      return `Dimension "${dimension}" not Found`
  }
}

const getSubDimensionTitle = (dimension, subdimension) => {
  const panel = Config.getConfig().panel_text;
  if (dimension < panel.length && subdimension < panel[dimension].indicators.length) {
    let messageId = `subdimension_${dimension}_${subdimension}_Title`;
    if (messageId in messages) {
      return this.formatMessage(messages[messageId]);
    } else {
      let missing_subdimension_Title = {
        id: 'AppTools.missing_subdimension_Title',
        description: `Texto para el título de subdimensión ${dimension}.${subdimension}`,
        defaultMessage: `NO TEXT FOR SUBDIMENSION ${dimension}.${subdimension}`
      };
      return this.formatMessage(missing_subdimension_Title);
    }
    // return panel[dimension].indicators[subdimension].title
  } else {
    return "Change me!"
  }
}

// get section title, use diferent section namespaces...?
const getSectionText = (namespace, levels, element) => {
  // levels is an array wih section path [0,1,1] = "0.1.1"
  const section_path = levels.join("_");
  let messageId = `${namespace}_${section_path}_${element}`;
  if (messageId in messages) {
    return this.formatMessage(messages[messageId]);
  } else {
    return  `no Title for "${namespace}_${section_path}"`;
  }
}

// 

const appTools = {
  getDefaultLanguage,
  getActualLanguage,
  getDimensionSubtitle,
  getComposedDataSource,
  importFormatter,
  getDimensionTitle,
  getSubDimensionTitle,
  getSectionText
}

export default appTools



// WEBPACK FOOTER //
// ./src/utils/app/appTools.js